import { Search } from "lucide-react";
import { DISCIPLINES, FOCUS } from "../lib/api";

export const FilterBar = ({ discipline, setDiscipline, focus, setFocus, search, setSearch, sort, setSort }) => {
  return (
    <div data-testid="filter-bar" className="space-y-4">
      <div className="relative">
        <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-black/50" />
        <input
          data-testid="search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search opportunities, orgs, keywords…"
          className="w-full brutal-border bg-white pl-10 pr-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-pink"
        />
      </div>

      <div className="flex flex-wrap gap-2 items-center">
        <span className="label-caps text-black/50 mr-1">Discipline:</span>
        {DISCIPLINES.map((d) => (
          <button
            key={d}
            data-testid={`filter-discipline-${d}`}
            onClick={() => setDiscipline(d)}
            className={`label-caps px-3 py-2 border-2 border-black transition-colors ${
              discipline === d ? "bg-black text-white" : "bg-white text-black hover:bg-pink hover:text-black"
            }`}
          >
            {d}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-2 items-center">
        <span className="label-caps text-black/50 mr-1">Focus:</span>
        {FOCUS.map((f) => (
          <button
            key={f}
            data-testid={`filter-focus-${f}`}
            onClick={() => setFocus(f)}
            className={`label-caps px-3 py-2 transition-colors ${
              focus === f ? "bg-pink text-black" : "bg-white text-black border-2 border-black hover:bg-pink"
            }`}
          >
            {f}
          </button>
        ))}
      </div>

      {setSort && (
        <div className="flex flex-wrap gap-2 items-center">
          <span className="label-caps text-black/50 mr-1">Sort:</span>
          <button
            data-testid="sort-deadline"
            onClick={() => setSort("deadline")}
            className={`label-caps px-3 py-2 border-2 border-black transition-colors ${
              sort === "deadline" ? "bg-black text-white" : "bg-white text-black hover:bg-pink hover:text-black"
            }`}
          >
            By Deadline
          </button>
          <button
            data-testid="sort-newest"
            onClick={() => setSort("newest")}
            className={`label-caps px-3 py-2 border-2 border-black transition-colors ${
              sort === "newest" ? "bg-black text-white" : "bg-white text-black hover:bg-pink hover:text-black"
            }`}
          >
            Newest
          </button>
        </div>
      )}
    </div>
  );
};
